import React from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";

const StyledHeader = styled(Box)(({}) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  paddingBottom: "1rem",
  paddingRight: "10px",
}));

const StyledOrganizationsIcon = styled(CorporateFareIcon)(({ theme }) => ({
  marginLeft: 16,
  fontSize: 24,
  color: theme.palette.primary.main,
  "&:hover": {
    cursor: "pointer",
  },
}));

const OrganizationsHeader = () => {
  return (
    <StyledHeader>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 1,
          alignItems: "center",
          marginTop: 5,
        }}
      >
        <Typography
          ml={2}
          variant="h1"
          fontWeight={700}
          fontSize={26}
          sx={{ alignSelf: "flex-end" }}
          color="primary.main"
        >
          Organizations
        </Typography>
        <StyledOrganizationsIcon />
      </Box>
    </StyledHeader>
  );
};

export default OrganizationsHeader;
